<template>
  <div>
    <v-layout column>
      <v-layout justify-center>
        <v-dialog
          v-model="progressDialog"
          persistent
          width="300">
          <v-card
            color="green"
            dark
          >
            <v-card-text>
              Por favor aguarde
              <v-progress-linear
                v-model="progressLoaded"
                :indeterminate="false"
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <header class="pdf-viewer__header box-shadow">
          <div class="pdf-preview-toggle">
            <v-btn @click.prevent.stop="togglePreview" flat
                   dark
                   small
                   fab class="icon">
              <v-icon>
                {{isPreviewEnabled ? 'mdi-arrow-expand-left' : 'mdi-arrow-expand-right'}}
              </v-icon>
            </v-btn>
          </div>

          <PDFPaginator

            v-model="currentPage"
            :pageCount="pageCount"
            class="header-item"
          />

          <v-divider vertical dark />

          <PDFZoom
            :scale="scale"
            @change="updateScale"
            @fit="updateFit"
            class="header-item"
          />

          <slot name="header"></slot>
        </header>

        <div class="pdf-container">
          <PDFData
            class="pdf-viewer__main"
            @page-count="updatePageCount"
            @page-focus="updateCurrentPage"
            @document-rendered="onDocumentRendered"
            @document-errored="onDocumentErrored"
            @progress-updated="onProgressUpdated">

            <PDFPreview
              slot="preview"
              slot-scope="{pages}"
              v-show="isPreviewEnabled"
              class="pdf-viewer__preview"
              v-bind="{pages, scale, currentPage, pageCount, isPreviewEnabled}"
            />

            <PDFDocument
              :style="presentation && 'top: 0'"
              class="pdf-viewer__document"
              :class="{ 'preview-enabled': isPreviewEnabled }"
              slot="document"
              slot-scope="{pages}"
              v-bind="{pages, scale, optimalScale, fit, currentPage, pageCount, isPreviewEnabled}"
              @scale-change="updateScale"
            />
          </PDFData>
        </div>

      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import PDFDocument from '@/components/pdf/PDFDocument';
import PDFData from '@/components/pdf/PDFData';
import PDFPaginator from '@/components/pdf/PDFPaginator';
import PDFPreview from '@/components/pdf/PDFPreview';
import PDFZoom from '@/components/pdf/PDFZoom';

export default {
  name: 'PdfViewer',
  components: {
    PDFDocument,
    PDFData,
    PDFPaginator,
    PDFPreview,
    PDFZoom,
  },
  props: ['progressDialog', 'presentation'],
  data() {
    return {
      scale: undefined,
      optimalScale: 2,
      fit: undefined,
      currentPage: 1,
      pageCount: undefined,
      isPreviewEnabled: false,
      progressLoaded: 0,
    };
  },
  methods: {
    onProgressUpdated(progress) {
      this.progressLoaded = Math.round(progress);
    },
    floor(value, precision) {
      const multiplier = 10 ** (precision || 0);
      return Math.floor(value * multiplier) / multiplier;
    },
    onDocumentRendered() {
      this.progressLoaded = 0;
      this.$emit('document-rendered');
    },
    onDocumentErrored(e) {
      this.$emit('document-errored', e);
    },
    updateScale({ scale, isOptimal = false }) {
      const roundedScale = this.floor(scale, 2);
      if (isOptimal) this.optimalScale = roundedScale;
      this.scale = roundedScale;
    },
    updateFit(fit) {
      this.fit = fit;
    },
    updatePageCount(pageCount) {
      this.pageCount = pageCount;
    },
    updateCurrentPage(pageNumber) {
      this.currentPage = pageNumber;
    },
    togglePreview() {
      this.isPreviewEnabled = !this.isPreviewEnabled;
    },
  },
  mounted() {
    document.body.classList.add('overflow-hidden');
  },
};

</script>

<style scoped>
  .pdf-viewer__header {
    background: rgba(0, 0, 0, 0.75);
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
  }
  .header-item {
    margin: 0 1.5em;
  }

  .pdf-viewer .pdf-viewer__document,
  .pdf-viewer .pdf-viewer__preview {
    top: 70px;
  }

  .pdf-viewer__preview {
    display: block;
    width: 15%;
    right: 85%;
  }

  .pdf-viewer__document {
    top: 65px;
    width: 100%;
    left: 0;
  }

  .pdf-viewer__document.preview-enabled {
    width: 85%;
    left: 15%;
  }

  @media print {
    header {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pdf/PdfViewer.vue